export const calcOffset = (page, limit) => (page - 1) * limit;
export const calcPreviousOffset = (offset, limit) => offset - limit;
export const calcNextOffset = (offset, limit) => offset + limit;
//# sourceMappingURL=utils.js.map